
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinchichwad() {



const cardData = {
  keyword: 'Cab Service in Chinchwad MIDC Pune',
  heading: 'eTravo: Dependable and Professional Corporate Cab Services in Chinchwad MIDC Pune',
  headingDescription: 'eTravo specializes in offering comprehensive corporate cab services in Chinchwad MIDC Pune, providing businesses and employees with reliable, safe, and comfortable transportation solutions. Our services are designed to meet the diverse needs of the industrial and commercial sectors, ensuring timely staff commutes, executive travel, and client transportation with flexible scheduling and GPS-tracked vehicles. With a focus on professionalism and customer satisfaction, eTravo is your trusted partner for corporate mobility in Chinchwad MIDC and surrounding Pune areas.',

  top: 'Prominent Industrial and Business Locations in Chinchwad MIDC Pune Served by eTravo',
  topPlaces: [
    {
      title: 'Chinchwad Industrial Estate',
      description: 'A key industrial zone housing numerous manufacturing units and factories. eTravo’s corporate cab services facilitate smooth daily commutes for the workforce, ensuring punctuality and comfort.'
    },
    {
      title: 'Pimpri-Chinchwad IT Park',
      description: 'An emerging IT hub with multiple tech companies and startups. Our cab services support professionals commuting to this fast-growing area with reliable, safe transport options.'
    },
    {
      title: 'MIDC Chinchwad Commercial Complex',
      description: 'A central business district offering office spaces and commercial establishments. eTravo provides dedicated corporate cab services tailored to the needs of businesses and visiting clients here.'
    },
    {
      title: 'Kirloskar Group Facilities',
      description: 'One of the largest industrial conglomerates in the area. We offer customized transportation solutions for their employees and executives, ensuring operational efficiency.'
    },
    {
      title: 'Automotive Parts Manufacturing Units',
      description: 'Numerous automotive component manufacturers operate here. Our fleet manages staff transport with multi-stop routes and shift-based scheduling to accommodate diverse work hours.'
    },
    {
      title: 'Chinchwad Railway Station',
      description: 'A major transit point connecting Chinchwad to Pune and beyond. eTravo’s cab services provide last-mile connectivity for employees and visitors arriving via train.'
    },
    {
      title: 'EON Free Zone',
      description: 'A Special Economic Zone (SEZ) with a mix of IT and manufacturing companies. Our corporate cab solutions ensure timely employee shuttles and client transfers.'
    },
    {
      title: 'Pimpri-Chinchwad Municipal Corporation (PCMC) Offices',
      description: 'Government offices requiring reliable staff transportation. eTravo caters to the official commute needs with punctual and professional cab services.'
    },
    {
      title: 'Chinchwad Bus Depot',
      description: 'An important public transport hub. eTravo supplements public transport by offering comfortable and direct corporate cab rides for daily commuters.'
    },
    {
      title: 'Chinchwad Market Area',
      description: 'A bustling commercial marketplace. Our cab services assist businesses with client pickups and delivery coordination within the area.'
    }
  ],

  services: [
    {
      name: 'Chinchwad MIDC Corporate Cab Rentals',
      description: 'Tailored cab rental plans for businesses operating in Chinchwad MIDC, including long-term contracts and flexible booking options to suit corporate schedules and requirements.'
    },
    {
      name: 'Employee Transport Cab Chinchwad MIDC',
      description: 'Daily and shift-based employee transport services with reliable pickup and drop timings, professional drivers, and well-maintained vehicles to ensure safety and comfort.'
    },
    {
      name: 'Business Cab Services Chinchwad MIDC',
      description: 'Comprehensive business cab solutions for inter-office travel, client meetings, and industrial site visits, offering a fleet ranging from economy sedans to executive SUVs.'
    },
    {
      name: 'Corporate Staff Cabs Chinchwad',
      description: 'Structured transportation plans for staff with optimized routes, multi-stop pickups, and real-time tracking to improve operational efficiency and employee satisfaction.'
    },
    {
      name: 'Reliable Corporate Cab Service Chinchwad MIDC',
      description: 'Trusted by numerous companies for punctuality, vehicle cleanliness, and courteous chauffeurs, ensuring seamless daily commutes and corporate travel.'
    },
    {
      name: 'AC Corporate Cabs Chinchwad',
      description: 'All vehicles are air-conditioned and sanitized regularly, providing a comfortable and hygienic environment, especially suited for Pune’s climate.'
    },
    {
      name: 'Staff Pickup and Drop Cab Chinchwad MIDC',
      description: 'Flexible scheduling for staff pickup and drop services, available 24/7 to accommodate varying shifts and operational demands in the industrial area.'
    },
    {
      name: 'Affordable Business Cab Rentals Chinchwad MIDC',
      description: 'Cost-effective corporate cab rental solutions with transparent pricing, ride options, and customizable billing plans tailored to different business sizes.'
    },
    {
      name: 'Executive Cab Services Chinchwad',
      description: 'Premium transportation services for executives and VIPs featuring luxury vehicles, professional chauffeurs, and priority scheduling to maintain business decorum.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Chinchwad MIDC',
      description: 'Comprehensive monthly plans covering employee commutes, event transport, and business trips, with dedicated support and real-time fleet management.'
    },
    {
      name: 'Industrial Area Employee Transport Chinchwad',
      description: 'End-to-end transport coordination for industrial employees, ensuring timely pickups, multi-route optimization, and safety compliance.'
    },
    {
      name: 'Corporate Client Cabs Chinchwad MIDC',
      description: 'Professional client transport services designed to create a positive impression with punctual, comfortable, and well-managed cab rides.'
    },
    {
      name: 'Business Meeting Cabs Chinchwad MIDC',
      description: 'On-demand cab services tailored for quick and reliable transport to meetings, conferences, and site visits within Chinchwad and adjacent areas.'
    },
    {
      name: 'Chinchwad Industrial Area Cab Hire',
      description: 'Flexible cab hire options for staff commutes, business events, and industrial operations, with scalable fleet availability and round-the-clock service.'
    },
    {
      name: 'Corporate Shuttle Cabs Chinchwad MIDC',
      description: 'Group shuttle services to efficiently transport large teams between offices, industrial units, and other key locations within the Chinchwad MIDC.'
    }
  ],

  tableData: [
    ['Chinchwad MIDC Corporate Cab Rentals', 'Employee Transport Cab Chinchwad MIDC'],
    ['Business Cab Services Chinchwad MIDC', 'Corporate Staff Cabs Chinchwad'],
    ['Reliable Corporate Cab Service Chinchwad MIDC', 'AC Corporate Cabs Chinchwad'],
    ['Staff Pickup and Drop Cab Chinchwad MIDC', 'Affordable Business Cab Rentals Chinchwad MIDC'],
    ['Executive Cab Services Chinchwad', 'Monthly Corporate Cab Rentals Chinchwad MIDC'],
    ['Industrial Area Employee Transport Chinchwad', 'Corporate Client Cabs Chinchwad MIDC'],
    ['Business Meeting Cabs Chinchwad MIDC', 'Chinchwad Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Chinchwad MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Customized Corporate Cab Solutions for Chinchwad MIDC Pune",
        "WhyChoosedescription": "eTravo specializes in providing tailored cab services for businesses operating in the Chinchwad Industrial Area MIDC, Pune. We understand the unique transportation challenges of this industrial hub and offer solutions that ensure your employees arrive on time, every time. Our service helps reduce commute-related stress and enhances overall workforce productivity."
    },
    {
        "WhyChooseheading": "Comprehensive Fleet to Meet Diverse Corporate Needs",
        "WhyChoosedescription": "Our wide-ranging fleet comprises sedans, SUVs, and multi-utility vehicles (MUVs), enabling companies to select vehicles best suited for daily employee commutes, client meetings, or transporting teams between multiple office locations across Pune."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Deep Knowledge of Chinchwad MIDC Routes",
        "WhyChoosedescription": "Our professional drivers are extensively trained and highly familiar with the road networks, shortcuts, and traffic patterns in and around Chinchwad MIDC. This expertise ensures timely pickups and drop-offs while navigating Pune’s busy industrial zones efficiently."
    },
    {
        "WhyChooseheading": "Flexible and Convenient Booking Options for Corporate Clients",
        "WhyChoosedescription": "We provide a range of booking options, including on-demand rides, advance scheduling, and long-term corporate contracts. This flexibility allows businesses to customize transportation plans according to changing employee shift timings and project demands."
    },
    {
        "WhyChooseheading": "Advanced Real-Time Tracking for Transparency and Safety",
        "WhyChoosedescription": "All cabs are equipped with GPS tracking systems that allow corporate clients to monitor their employees’ journeys in real-time. This feature enhances safety, ensures accountability, and enables swift responses to any travel disruptions."
    },
    {
        "WhyChooseheading": "Transparent and Detailed Billing for Simplified Expense Management",
        "WhyChoosedescription": "We provide clear, itemized invoices detailing trip logs, fare breakdowns, and any additional charges, making it easier for corporate finance teams to manage transportation expenses and process reimbursements accurately."
    },
    {
        "WhyChooseheading": "Strict Safety and Hygiene Protocols to Protect Employees",
        "WhyChoosedescription": "In line with health guidelines, our vehicles are regularly sanitized, and drivers follow strict hygiene protocols including mask-wearing and sanitizing hands, ensuring a safe and comfortable travel environment for every passenger."
    },
    {
        "WhyChooseheading": "Dedicated Account Managers for Seamless Corporate Support",
        "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who handles all transportation needs, addresses queries promptly, and offers personalized solutions to ensure a smooth and hassle-free travel experience."
    }
]
}
const faqData = [
    [
        {
            question: "Which areas are covered by your corporate cab service in Chinchwad MIDC Pune?",
            answer: "Our services cover the entire Chinchwad Industrial Area MIDC, including nearby zones such as Pimpri, Bhosari, and other prominent industrial sectors of Pune."
        },
        {
            question: "Can we arrange recurring rides for employees at Chinchwad MIDC?",
            answer: "Yes, we offer recurring ride scheduling to ensure consistent and timely transportation for your workforce."
        },
        {
            question: "Do you provide monthly billing options for corporate clients?",
            answer: "Absolutely, we facilitate monthly billing cycles with comprehensive invoices to help your finance team manage expenses efficiently."
        },
        {
            question: "Are your drivers trained to maintain corporate professionalism?",
            answer: "Yes, all our drivers receive training in corporate etiquette and customer service to provide a professional and courteous travel experience."
        },
        {
            question: "What measures do you take to ensure passenger safety during rides?",
            answer: "We implement real-time GPS tracking, regular vehicle maintenance, driver background checks, and stringent hygiene protocols to guarantee safe travel for all passengers."
        },
        {
            question: "Is there dedicated support available for corporate clients?",
            answer: "Yes, we offer dedicated account management and a support helpline exclusively for corporate clients to address any queries or service customization needs."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Anil Joshi",
        designation: "Logistics Manager, PuneTech Manufacturing",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s service in Chinchwad MIDC has been a game-changer for our employee commute logistics. Their punctuality and driver professionalism are outstanding.”"
    },
    {
        name: "Ms. Ritu Deshmukh",
        designation: "HR Head, Alpha Industries Pune",
        rating: [1, 1, 1, 1, 1],
        text: "“The flexible booking options and real-time tracking make eTravo our preferred corporate cab provider in Pune. Highly recommended!”"
    }
];























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Chinchwad MIDC Pune",
  "image": "https://www.etravo.in/images/keyword/cab-service-chinchwad-midc-pune.jpg",
  "description": "Book reliable cab services in Chinchwad MIDC Pune for corporate staff transport, business meetings, and industrial area commutes. Affordable AC corporate cabs with professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7935"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-chinchwad-midc-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Cab Service in Chinchwad MIDC Pune | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Chinchwad MIDC Pune for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/54.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinchichwad;